(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ds24-chat-control"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  const launcher = document.getElementById('Ds24ChatLauncher');
  const status = document.getElementById('Ds24ChatStatus');
  if (!launcher || !status) return;
  let api;
  let userRequested = false;
  let blocked;
  let loading = false;
  let timer;
  let script;
  const pathBlocked = /\/(?:cart|checkouts?|thank_you)(?:\/|$)/.test(location.pathname);
  const drawer = document.getElementById('CartDrawer');
  const setStatus = (text) => {
    status.textContent = text;
    status.hidden = !text;
  };
  const setOpen = (open) => {
    root.toggleAttribute('data-ds24-chat-open', open);
    launcher.setAttribute('aria-expanded', String(open));
  };
  const sync = () => {
    const next = pathBlocked || Boolean(drawer && (drawer.hasAttribute('open') || drawer.open === true || drawer.getAttribute('aria-hidden') === 'false'));
    root.toggleAttribute('data-ds24-chat-blocked', next);
    if (next === blocked) return;
    blocked = next;
    if (blocked) {
      userRequested = false;
      setOpen(false);
      setStatus('');
      if (api) {
        api.close();
        api.hide();
      }
    }
  };
  const open = () => {
    if (!api || !userRequested || blocked) return;
    setStatus('');
    setOpen(true);
    api.show();
    api.open();
  };
  const ready = () => {
    if (api || !window.tidioChatApi) return;
    clearTimeout(timer);
    loading = false;
    launcher.removeAttribute('aria-busy');
    launcher.setAttribute('aria-label', 'Chat öffnen');
    setStatus('');
    api = window.tidioChatApi;
    api.on('open', () => {
      if (!userRequested || blocked) {
        setOpen(false);
        api.close();
      }
    });
    api.on('close', () => {
      userRequested = false;
      setOpen(false);
    });
    sync();
    if (userRequested && !blocked) open();
    else {
      api.close();
      api.hide();
    }
  };
  const failed = () => {
    if (api) return;
    clearTimeout(timer);
    loading = false;
    userRequested = false;
    launcher.removeAttribute('aria-busy');
    launcher.setAttribute('aria-label', 'Chat erneut laden');
    setStatus('Chat konnte nicht geladen werden. Bitte erneut versuchen.');
    if (script) script.remove();
    script = null;
  };
  const load = () => {
    if (loading) return;
    loading = true;
    launcher.setAttribute('aria-busy', 'true');
    launcher.setAttribute('aria-label', 'Chat wird geladen');
    setStatus('Chat wird geladen …');
    script = document.createElement('script');
    script.id = 'Ds24TidioScript';
    script.src = 'https://code.tidio.co/kybzsztucavuonlygro7fr0z10cf25ko.js';
    script.async = true;
    script.onerror = failed;
    script.onload = () => {
      if (window.tidioChatApi) window.tidioChatApi.on('ready', ready);
    };
    timer = setTimeout(failed, 20000);
    document.body.appendChild(script);
  };
  launcher.addEventListener('click', () => {
    sync();
    if (blocked || loading) return;
    userRequested = true;
    if (api) open();
    else load();
  });
  sync();
  root.setAttribute('data-ds24-chat-ready', '');
  if (drawer) new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['open', 'aria-hidden', 'class'] });
  document.addEventListener('tidioChat-ready', ready);
  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', ready);
    ready();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets-sticky"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    const search = event.target.closest('[data-ds24-vendor-search]');
    if (!search) return;

    const scope = search.closest('[data-ds24-vendor-scope]');
    if (!scope) return;

    const query = search.value.trim().toLocaleLowerCase('de');
    const items = scope.querySelectorAll('[data-ds24-vendor-item]');
    let visible = 0;

    items.forEach((item) => {
      const matches = item.textContent.toLocaleLowerCase('de').includes(query);
      item.hidden = !matches;
      if (matches) visible += 1;
    });

    const empty = scope.querySelector('[data-ds24-vendor-empty]');
    if (empty) empty.hidden = visible !== 0;
  });
  } catch(e) { console.error(e); }
})();

})();
